import { useState } from 'react';
import { NumberFormattedField } from 'components';
import {
  WaterfallCalculatorTable,
  WaterfallCalculatorTableProps,
} from './components';
import { useNumberFormattedFiedStyles } from './styles';
import { IWaterfallCalculatorProps } from './types';


const WaterfallCalculator = (props: IWaterfallCalculatorProps) => {
  const [exitEquityValue, setExitEquityValue] = useState<string>('');

  const classes = useNumberFormattedFiedStyles();

  const waterfallCalculatorTableProps: WaterfallCalculatorTableProps = {
    ...props,
    exitEquityValue,
  };

  return (
    <>
      <div className={classes.equityValueInput}>
        <NumberFormattedField
          id="exit-equity-value"
          type="text"
          name="exitEquityValue"
          label="Exit Equity Value"
          value={exitEquityValue}
          onChange={e => setExitEquityValue(e.target.value)}
          currencyCode="USD"
          format="currency"
          variant="standard"
        />
      </div>
      <WaterfallCalculatorTable {...waterfallCalculatorTableProps} />
    </>
  );
};

export default WaterfallCalculator;
